interface ValidationItem {
  if?: boolean;
  onError: () => void;
}

export const validateError = (validateList: ValidationItem[], successCallback: () => void): void => {
  const invalidItem = validateList.find((validate) => validate.if);

  if (invalidItem && invalidItem.onError) {
    invalidItem.onError();
    return;
  }
  successCallback();
};
